const facilityEndpoints = {
  FACILITIES: (clientId: string, params?: Record<string, string>) => {
    const base = `loopay-facility-management/clients/${clientId}/facilities`;
    if (!params || Object.keys(params).length === 0) {
      return base;
    }
    return `${base}?${new URLSearchParams(params).toString()}`;
  },
  FACILITY_TEMP: (clientId: string) =>
    `loopay-facility-management/clients/${clientId}/facilities/temp`,
  FACILITY_PATCH: (facilityId: string) =>
    `loopay-facility-management/facilities/${facilityId}`,
  FACILITY_GET: (facilityId: string) =>
    `loopay-employee-management/facilities/${facilityId}/details`,
  FACILITY_DRAFT_GET: (facilityId: string) =>
    `loopay-facility-management/facilities/${facilityId}`,
  FACILITY_FINALIZE: (clientId: string, facilityId: string) =>
    `loopay-facility-management/clients/${clientId}/facilities/${facilityId}/finalize`,
  FACILITY_STATUS: (facilityId: string) =>
    `loopay-facility-management/facilities/${facilityId}/status`,
} as const;

export default facilityEndpoints;
